import { Box } from '@betterment/samba-react';
import { PlaceholderAreaChart, BalanceChart as SharedBalanceChart } from '@betterment/shared-components';
import { ParentSize } from '@visx/responsive';

import { UserBalancePerformanceQuery } from './graphql/userPerformanceBalance.generated';

export type BalanceChartProps = {
  history: UserBalancePerformanceQuery['performance']['history'] | undefined;
  balanceDetailsId: string;
  loading: boolean;
};

export const BalanceChart: React.FC<BalanceChartProps> = ({ history, balanceDetailsId, loading = true }) => {
  return (
    <Box css={{ height: '350px' }}>
      <ParentSize debounceTime={10}>
        {({ width, height }) =>
          !loading && history && history.timeSeries.length > 0 ? (
            <SharedBalanceChart
              data={history.timeSeries}
              width={width}
              height={height}
              aria-describedby={balanceDetailsId}
              aria-label="Balance Chart"
            />
          ) : (
            <PlaceholderAreaChart
              width={width}
              height={height}
              variant={loading || !history ? 'loading' : 'empty'}
              aria-describedby={balanceDetailsId}
              aria-label={!history ? 'Loading chart' : 'No data available'}
            />
          )
        }
      </ParentSize>
    </Box>
  );
};
